var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/star_blue.4980adda.png","uri@2x": __webpack_public_path__ + "static/media/star_blue.31713d57.png","uri@3x": __webpack_public_path__ + "static/media/star_blue.cd211ba9.png",
    width: 5,
    height: 5
});